(()=>{
'use strict';
const key='ug-product-swipe-v1';
const path=value=>{try{const u=new URL(value,location.href);return u.origin===location.origin&&/\/products\/[^/]+\/?$/.test(u.pathname)?u.pathname:null}catch{return null}};
const unique=values=>[...new Set(values.map(path).filter(Boolean))];
const save=urls=>{try{sessionStorage.setItem(key,JSON.stringify({time:Date.now(),urls}))}catch{}};
document.addEventListener('click',event=>{
  const link=event.target.closest?.('a[href]');
  if(!link||!path(link.href)||link.target==='_blank'||event.ctrlKey||event.metaKey)return;
  const card=link.closest('.card-wrapper,.product-card-wrapper,[data-product-card]');
  if(!card)return;
  const container=card.closest('#product-grid,.product-grid,.grid,ul')||card.parentElement;
  const urls=unique([...container.querySelectorAll('a[href]')].map(a=>a.href));
  if(urls.length>1)save(urls);
},true);
const nav=document.querySelector('[data-ug-product-swipe]');
if(!nav)return;
let urls=[];
try{const cached=JSON.parse(sessionStorage.getItem(key)||'null');if(cached&&Date.now()-cached.time<3600000&&Array.isArray(cached.urls))urls=unique(cached.urls)}catch{}
const current=path(location.href);
if(urls.length<2||!urls.includes(current)){
  try{urls=unique(JSON.parse(nav.querySelector('[data-ug-swipe-products]').textContent))}catch{return}
}
if(urls.length<2||!urls.includes(current))return;
save(urls);
nav.hidden=false;
let navigating=false;
const blocked=()=>document.querySelector('dialog[open],.drawer.active,.menu-opening,details.ug-size-notice[open]')||document.body.classList.contains('ug-cart-open');
const go=direction=>{
  if(navigating||blocked())return;
  const index=urls.indexOf(current);
  const target=urls[(index+direction+urls.length)%urls.length];
  if(!target||target===current)return;
  navigating=true;
  const u=new URL(target,location.origin);
  const preview=new URL(location.href).searchParams.get('preview_theme_id');
  if(preview)u.searchParams.set('preview_theme_id',preview);
  location.assign(u.href);
};
for(const button of nav.querySelectorAll('[data-direction]')){
  let start=null,dragged=false;
  button.addEventListener('pointerdown',event=>{
    if(!event.isPrimary||event.pointerType==='mouse'||blocked())return;
    start={x:event.clientX,y:event.clientY,time:performance.now(),id:event.pointerId};
    dragged=false;
    button.setPointerCapture?.(event.pointerId);
  });
  button.addEventListener('pointermove',event=>{
    if(!start||event.pointerId!==start.id)return;
    const dx=event.clientX-start.x,dy=event.clientY-start.y;
    if(Math.abs(dy)>18&&Math.abs(dy)>Math.abs(dx)){start=null;dragged=true;return}
    if(Math.abs(dx)>12)dragged=true;
  });
  button.addEventListener('pointerup',event=>{
    if(!start)return;
    const dx=event.clientX-start.x,dy=event.clientY-start.y;
    const valid=performance.now()-start.time<1000&&Math.abs(dx)>=65&&Math.abs(dx)>Math.abs(dy)*1.7;
    start=null;
    if(valid){dragged=true;go(dx<0?1:-1)}
  });
  button.addEventListener('pointercancel',()=>{start=null;dragged=true});
  button.addEventListener('lostpointercapture',()=>{start=null});
  button.addEventListener('click',event=>{
    event.preventDefault();
    if(dragged){dragged=false;return}
    // Touch navigation requires a deliberate swipe; taps do not change models.
    if(event.detail===0)go(Number(button.dataset.direction));
  });
}
window.addEventListener('pageshow',()=>{navigating=false});
})();